import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Loader from '../Loader';
import { MultiSelect } from 'primereact/multiselect';
import { Calendar } from 'primereact/calendar';
import * as XLSX from 'xlsx';

const fmtNum = (value, decimals = 2) =>
    value != null ? Number(value).toLocaleString('pt-BR', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }) : '-';

const fmtPct = (value, decimals = 1) =>
    value != null ? fmtNum(value, decimals) + '%' : '-';

const fmtBRL = (value) =>
    value != null ? 'R$ ' + fmtNum(value, 2) : '-';

export default class BonificacaoForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            mes: new Date(),
            operadores: [],
            operadoresOptions: [],
            errors: {},
            loading: false,
            resultados: [],
            mesCorrente: '',
            mesAnterior: '',
            mediaQualidadeEquipe: null,
            mediaProdutividadeEquipe: null,
            exibirBimestre: false,
        };
    }

    componentDidMount = async () => {
        await this.loadOperadores();
    }

    loadOperadores = async()=>{
        try {
            let mesReferencia = `${this.state.mes.getFullYear()}-${String(this.state.mes.getMonth() + 1).padStart(2, '0')}`;
            const response = await axios.get(route('bonificacao.operadores', { mesReferencia }));
            this.setState({ operadoresOptions: response.data });
        } catch (e) {
            console.error(e);
        }
    }

    validate = () => {
        const errors = {};

        if (!this.state.mes) {
            errors.mes = 'O campo mês é obrigatório.';
        }

        if (this.state.operadores.length === 0) {
            errors.operadores = 'É necessário selecionar pelo menos um operador.';
        }


        return errors;
    }

    submit = async () => {
        const errors = this.validate();

        if (Object.keys(errors).length > 0) {
            this.setState({ errors });
            return;
        }

        this.setState({ loading: true, errors: {}, resultados: [] });

        try {
            const mes = this.state.mes
                ? `${this.state.mes.getFullYear()}-${String(this.state.mes.getMonth() + 1).padStart(2, '0')}`
                : null;

            const response = await axios.post(route('bonificacao.post'), {
                mes,
                operadores: this.state.operadores,
            });

            this.setState({
                resultados:              response.data.resultados,
                mesCorrente:             response.data.mes_corrente,
                mesAnterior:             response.data.mes_anterior,
                mediaQualidadeEquipe:     response.data.media_qualidade_equipe,
                mediaProdutividadeEquipe: response.data.media_produtividade_equipe,
                exibirBimestre:          (this.state.mes.getMonth() + 1) % 2 !== 0,
            });
        } catch (e) {
            console.error(e);
            if( e.response && e.response.data && e.response.data.errors){
                this.setState({ errors: e.response.data.errors });
            }
        } finally {
            this.setState({ loading: false });
        }
    }

    renderCardMediaQualidade() {
        const { mediaQualidadeEquipe, mediaProdutividadeEquipe, mesCorrente, resultados, exibirBimestre } = this.state;

        if (mediaQualidadeEquipe === null) return null;

        const valoresBimestre = resultados.map(r => r.mediaBimestre).filter(v => v != null);
        const mediaBimestreEquipe = valoresBimestre.length > 0
            ? valoresBimestre.reduce((acc, v) => acc + Number(v), 0) / valoresBimestre.length
            : null;

        const valoresMes = resultados.map(r => r.media).filter(v => v != null);
        const mediaDoMesEquipe = valoresMes.length > 0
            ? valoresMes.reduce((acc, v) => acc + Number(v), 0) / valoresMes.length
            : null;

        const card = (label, value, color, fmt = 'num', decimals = 2) => (
            <div className="col-12 col-md-3">
                <div className="card" style={{ borderLeft: `4px solid ${color}` }}>
                    <div className="card-body py-3">
                        <div className="text-muted" style={{ fontSize: '0.78rem', textTransform: 'uppercase', letterSpacing: '0.05em' }}>
                            {label}
                        </div>
                        <div style={{ fontSize: '1.6rem', fontWeight: 'bold', color, lineHeight: 1.3 }}>
                            {fmt === 'pct' ? fmtPct(value, decimals) : fmtNum(value, decimals)}
                        </div>
                        {mesCorrente && (
                            <div className="text-muted" style={{ fontSize: '0.8rem' }}>{mesCorrente}</div>
                        )}
                    </div>
                </div>
            </div>
        );

        return (
            <div className="row mt-4 mb-2">
                {card('Média de Qualidade da Equipe',     mediaQualidadeEquipe,     '#1a5c2a')}
                {card('Média de Produtividade da Equipe', mediaProdutividadeEquipe, '#1565c0', 'pct')}
                {mediaDoMesEquipe !== null && card('Média do Mês da Equipe', mediaDoMesEquipe, '#e65100', 'pct')}
                {exibirBimestre && mediaBimestreEquipe !== null && card('Média do Bimestre da Equipe', mediaBimestreEquipe, '#6a1b9a', 'pct')}
            </div>
        );
    }

    downloadExcel = () => {
        const { resultados, mesCorrente, mesAnterior, exibirBimestre } = this.state;

        const headers = [
            'Operador', 'Meta', 'Realizado', 'Qualidade', '% Qualidade',
            'Meta Individual', 'Produtividade', '% Produtividade',
            `Média de ${mesCorrente}`, 'R$ Bônus', '1° e 2° Lugar',
            ...(exibirBimestre ? [
                `Qualidade ${mesAnterior}`, `Média Qualidade ${mesAnterior}`,
                `Produtividade ${mesAnterior}`, `Média Produtividade ${mesAnterior}`,
                `Resultado ${mesAnterior}`, 'Média Bimestre', 'Recuperação Bimestral', 'Total a Receber',
            ] : []),
            'Elegível Bônus', 'Regras Não Atendidas',
        ];

        const rows = resultados.map(row => [
            row.operador ?? '',
            row.meta ?? '',
            row.realizado ?? '',
            row.qualidade ?? '',
            row.porcentagemQualidade ?? '',
            row.metaIndividual ?? '',
            row.produtividade ?? '',
            row.produtividadePorcentagem ?? '',
            row.media ?? '',
            row.valorBonus ?? '',
            row.bonusRanking > 0 ? row.bonusRanking : '',
            ...(exibirBimestre ? [
                row.qualidadeMesAnterior ?? '',
                row.mediaQualidadeMesAnterior ?? '',
                row.produtividadeMesAnterior ?? '',
                row.mediaProdutividade ?? '',
                row.resultadoMesAnterior ?? '',
                row.mediaBimestre ?? '',
                row.recuperacaoBimestral > 0 ? row.recuperacaoBimestral : '',
                row.totalReceber ?? '',
            ] : []),
            row.elegivelBonus ? 'Sim' : 'Não',
            (row.regrasNaoAtendidas ?? []).join('; '),
        ]);

        const ws = XLSX.utils.aoa_to_sheet([headers, ...rows]);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Bonificação');
        XLSX.writeFile(wb, `bonificacao_${mesCorrente || 'relatorio'}.xlsx`);
    }

    renderTabela() {
        const { resultados, mesCorrente, mesAnterior, exibirBimestre } = this.state;

        if (resultados.length === 0) return null;

        const thCorrente = { textAlign: 'center', verticalAlign: 'middle', whiteSpace: 'nowrap', padding: '14px 10px', backgroundColor: '#1a5c2a', color: '#fff' };
        const thAnterior = { textAlign: 'center', verticalAlign: 'middle', whiteSpace: 'nowrap', padding: '14px 10px', backgroundColor: '#2e7d32', color: '#fff' };
        const tdCenter   = { textAlign: 'center', verticalAlign: 'middle', padding: '6px 8px' };
        const tdLeft     = { verticalAlign: 'middle', padding: '6px 8px', whiteSpace: 'nowrap' };

        const porcColor = (val) => {
            if (val == null) return {};
            const n = Number(val);
            if (n >= 100) return { color: '#155724', fontWeight: 'bold' };
            if (n >= 95)  return { color: '#856404' };
            return { color: '#721c24' };
        };

        return (
            <div className="mt-4">
                <div className="d-flex justify-content-end mb-2">
                    <button
                        type="button"
                        className="btn btn-success btn-sm"
                        onClick={this.downloadExcel}
                    >
                        <i className="fa fa-file-excel-o mr-1" /> Download Excel
                    </button>
                </div>
            <div style={{ overflowX: 'auto', overflowY: 'visible', fontSize: '0.82rem', border: '1px solid #dee2e6', borderRadius: 4 }}>
                <table className="table table-bordered table-striped table-hover table-sm mb-0">
                    <thead>
                        <tr>
                            <th style={thCorrente}>Operador</th>
                            <th style={thCorrente}>Meta</th>
                            <th style={thCorrente}>Realizado</th>
                            <th style={thCorrente}>Qualidade</th>
                            <th style={thCorrente}>%</th>
                            <th style={thCorrente}>Meta<br/>Individual</th>
                            <th style={thCorrente}>Produtividade</th>
                            <th style={thCorrente}>%</th>
                            <th style={thCorrente}>Média<br/>de {mesCorrente}</th>
                            <th style={thCorrente}>R$</th>
                            <th style={thCorrente}>1° e 2°<br/>Lugar</th>
                            {exibirBimestre && <th style={thAnterior}>Qualidade<br/>{mesAnterior}</th>}
                            {exibirBimestre && <th style={thAnterior}>Média<br/>Qualidade</th>}
                            {exibirBimestre && <th style={thAnterior}>Produtividade<br/>{mesAnterior}</th>}
                            {exibirBimestre && <th style={thAnterior}>Média<br/>Produtividade</th>}
                            {exibirBimestre && <th style={thAnterior}>Resultado<br/>{mesAnterior}</th>}
                            {exibirBimestre && <th style={thAnterior}>Média<br/>Bimestre</th>}
                            {exibirBimestre && <th style={thAnterior}>Recuperação<br/>Bimestral</th>}
                            {exibirBimestre && <th style={thAnterior}>Total<br/>a Receber</th>}
                        </tr>
                    </thead>
                    <tbody>
                        {resultados.map((row, index) => (
                            <tr key={index} style={!row.elegivelBonus ? { backgroundColor: '#fff8f8' } : {}}>
                                <td style={tdLeft}>
                                    <strong>{row.operador ?? '-'}</strong>
                                    {!row.elegivelBonus && (
                                        <span
                                            title={row.regrasNaoAtendidas.join('\n')}
                                            style={{ marginLeft: 6, color: '#dc3545', cursor: 'help' }}
                                        >
                                            <i className="fa fa-exclamation-circle" />
                                        </span>
                                    )}
                                </td>
                                <td style={tdCenter}>{row.meta ?? '-'}</td>
                                <td style={tdCenter}>{fmtNum(row.realizado)}</td>
                                <td style={tdCenter}>{fmtNum(row.qualidade)}</td>
                                        <td style={{ ...tdCenter, ...porcColor(row.porcentagemQualidade) }}>{fmtPct(row.porcentagemQualidade)}</td>
                                <td style={tdCenter}>{fmtNum(row.metaIndividual, 0)}</td>
                                <td style={tdCenter}>{fmtNum(row.produtividade)}</td>
                                <td style={{ ...tdCenter, ...porcColor(row.produtividadePorcentagem) }}>{fmtPct(row.produtividadePorcentagem)}</td>
                                <td style={{ ...tdCenter, ...porcColor(row.media) }}><strong>{fmtPct(row.media)}</strong></td>
                                <td style={{ ...tdCenter, fontWeight: 'bold', color: row.elegivelBonus ? '#155724' : '#6c757d' }}>
                                    {row.elegivelBonus ? fmtBRL(row.valorBonus) : <span title={row.regrasNaoAtendidas.join('\n')}>R$ 0,00</span>}
                                </td>
                                <td style={{ ...tdCenter, fontWeight: 'bold', color: '#b8860b' }}>
                                    {row.bonusRanking > 0 ? fmtBRL(row.bonusRanking) : ''}
                                </td>
                                {exibirBimestre && <td style={tdCenter}>{fmtNum(row.qualidadeMesAnterior)}</td>}
                                {exibirBimestre && <td style={tdCenter}>{fmtNum(row.mediaQualidadeMesAnterior)}</td>}
                                {exibirBimestre && <td style={tdCenter}>{fmtPct(row.produtividadeMesAnterior)}</td>}
                                {exibirBimestre && <td style={tdCenter}>{fmtPct(row.mediaProdutividade)}</td>}
                                {exibirBimestre && <td style={tdCenter}>{fmtPct(row.resultadoMesAnterior)}</td>}
                                {exibirBimestre && <td style={tdCenter}>{fmtPct(row.mediaBimestre)}</td>}
                                {exibirBimestre && (
                                    <td style={{ ...tdCenter, fontWeight: 'bold', color: row.recuperacaoBimestral > 0 ? '#6a1b9a' : '#6c757d' }}>
                                        {row.recuperacaoBimestral > 0 ? fmtBRL(row.recuperacaoBimestral) : '-'}
                                    </td>
                                )}
                                {exibirBimestre && <td style={{ ...tdCenter, fontWeight: 'bold', color: '#155724' }}>{fmtBRL(row.totalReceber)}</td>}
                            </tr>
                        ))}
                    </tbody>
                    <tfoot>
                        {(() => {
                            const sum = (field) => resultados.reduce((acc, r) => acc + (Number(r[field]) || 0), 0);
                            const avg = (field) => resultados.length > 0 ? sum(field) / resultados.length : 0;
                            const tfStyle = { textAlign: 'center', verticalAlign: 'middle', padding: '8px', backgroundColor: '#1a5c2a', color: '#fff', fontWeight: 'bold', whiteSpace: 'nowrap' };
                            return (
                                <tr>
                                    <td style={{ ...tfStyle, textAlign: 'left' }}>Total</td>
                                    <td style={tfStyle}>{fmtNum(sum('meta'), 0)}</td>
                                    <td style={tfStyle}>{fmtNum(sum('realizado'), 2)}</td>
                                    <td style={tfStyle}>{fmtNum(avg('qualidade'), 2)}</td>
                                    <td style={tfStyle}>{fmtPct(avg('porcentagemQualidade'), 2)}</td>
                                    <td style={tfStyle}>{fmtNum(sum('metaIndividual'), 0)}</td>
                                    <td style={tfStyle}>{fmtNum(sum('produtividade'), 2)}</td>
                                    <td style={tfStyle}>{fmtPct(avg('produtividadePorcentagem'), 2)}</td>
                                    <td style={tfStyle}>{fmtPct(avg('media'), 2)}</td>
                                    <td style={tfStyle}>{fmtBRL(sum('valorBonus'))}</td>
                                    <td style={tfStyle}>{fmtBRL(sum('bonusRanking'))}</td>
                                    {exibirBimestre && <td style={tfStyle}>{fmtNum(sum('qualidadeMesAnterior'), 2)}</td>}
                                    {exibirBimestre && <td style={tfStyle}>{fmtNum(sum('mediaQualidadeMesAnterior'), 2)}</td>}
                                    {exibirBimestre && <td style={tfStyle}>{fmtPct(avg('produtividadeMesAnterior'), 2)}</td>}
                                    {exibirBimestre && <td style={tfStyle}>{fmtPct(avg('mediaProdutividade'), 2)}</td>}
                                    {exibirBimestre && <td style={tfStyle}>{fmtPct(avg('resultadoMesAnterior'), 2)}</td>}
                                    {exibirBimestre && <td style={tfStyle}>{fmtPct(avg('mediaBimestre'), 2)}</td>}
                                    {exibirBimestre && <td style={tfStyle}>{fmtBRL(sum('recuperacaoBimestral'))}</td>}
                                    {exibirBimestre && <td style={tfStyle}>{fmtBRL(sum('totalReceber'))}</td>}
                                </tr>
                            );
                        })()}
                    </tfoot>
                </table>
            </div>
            </div>
        );
    }

    render() {
        const { mes, operadores, operadoresOptions, errors, loading } = this.state;

        return (
            <div>
                {loading && <Loader />}

                <div className="card shadow-sm mb-4">
                    <div className="card-header py-3">
                        <h6 className="mb-0" style={{ fontWeight: 600, letterSpacing: '0.03em' }}>
                            Relatório de Bonificação
                        </h6>
                    </div>
                    <div className="card-body">
                        <div className="form-group row align-items-end mb-0">
                            <div className="col-12 col-md-3">
                                <label className="font-weight-bold text-muted" style={{ fontSize: '0.82rem', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                                    Mês de referência
                                </label>
                                <Calendar
                                    value={mes}
                                    onChange={async (e) => {
                                        this.setState({ mes: e.value, operadores: [] });
                                        await this.loadOperadores();
                                    }}
                                    view="month"
                                    dateFormat="mm/yy"
                                    locale="pt-BR"
                                    appendTo={document.body}
                                    style={{ width: '100%' }}
                                    yearNavigator
                                    yearRange="2020:2035"
                                />
                                {errors.mes && (
                                    <div className="invalid-feedback" style={{ display: 'block' }}>
                                        {errors.mes}
                                    </div>
                                )}
                            </div>

                            <div className="col-12 col-md-6 mt-3 mt-md-0">
                                <label className="font-weight-bold text-muted" style={{ fontSize: '0.82rem', textTransform: 'uppercase', letterSpacing: '0.04em' }}>
                                    Operadores
                                </label>
                                <MultiSelect
                                    value={operadores}
                                    options={operadoresOptions}
                                    onChange={(e) => this.setState({ operadores: e.value })}
                                    optionLabel="label"
                                    optionValue="value"
                                    filter
                                    display="chip"
                                    placeholder="Selecione os operadores"
                                    style={{ width: '100%' }}
                                    appendTo={document.body}
                                    maxSelectedLabels={5}
                                />
                                {errors.operadores && (
                                    <div className="invalid-feedback" style={{ display: 'block' }}>
                                        {errors.operadores}
                                    </div>
                                )}
                            </div>

                            <div className="col-12 col-md-2 mt-3 mt-md-0">
                                <button
                                    type="button"
                                    className="btn btn-primary button-brain btn-block"
                                    onClick={this.submit}
                                >
                                    <i className="fa fa-search mr-1" /> Gerar
                                </button>
                            </div>
                            <div className="col-12 col-md-1 mt-2 mt-md-0">
                                <button
                                    type="button"
                                    className="btn btn-outline-secondary btn-block"
                                    title="Limpar"
                                    onClick={() => this.setState({
                                        mes: new Date(),
                                        operadores: [],
                                        errors: {},
                                        resultados: [],
                                        mesCorrente: '',
                                        mesAnterior: '',
                                        mediaQualidadeEquipe: null,
                                        mediaProdutividadeEquipe: null,
                                    })}
                                >
                                    <i className="fa fa-times" />
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                {this.renderCardMediaQualidade()}
                {this.renderTabela()}
            </div>
        );
    }
}

if (document.getElementById('js-bonificacao-form')) {
    ReactDOM.render(
        <BonificacaoForm />,
        document.getElementById('js-bonificacao-form')
    );
}
